import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateDownloadK8sAgent = document.createElement('template');

templateDownloadK8sAgent.innerHTML = `
  <style>${flexboxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>

    <gz-text fontsize='${FontSizes.HEADING_6}' lineHeight='1.2' class='k8s-page-text' id='downloadInstructions'></gz-text>

    <gz-title fontsize='${FontSizes.HEADING_5}' lineHeight='1.2' fontweight='${FontWeights.MEDIUM}' class='k8s-page-title' id='configurationTitle'></gz-title>
    <gz-form-field id='companyFormField' class="details-input-form-field" label='' required>
      <gz-single-select-complex gz-form-input cannotDelete='true' labelWidth='240'></gz-single-select-complex>
      <gz-input-error inputWidth="240"></gz-input-error>
    </gz-form-field>
    
    <div id="checkRequirementsSection" class="steps-section">
      <gz-title fontsize='${FontSizes.HEADING_5}' lineHeight='1.2' fontweight='${FontWeights.MEDIUM}' class='k8s-page-title' id='checkRequirementsTitle'></gz-title>

      <gz-enumeration-icon value="1">
        <div class="inner-steps-section">
          <gz-text fontSize="${FontSizes.HEADING_6}" class='k8s-page-text' id="checkStep1"></gz-text>
        </div>
      </gz-enumeration-icon>
      <gz-enumeration-icon value="2">
        <div class="inner-steps-section">
          <gz-text fontSize="${FontSizes.HEADING_6}" class='k8s-page-text' id="checkStep2"></gz-text>
        </div>
      </gz-enumeration-icon>
      <gz-enumeration-icon value="3">
        <div class="inner-steps-section">
          <gz-text fontSize="${FontSizes.HEADING_6}" class='k8s-page-text' id="checkStep3"></gz-text>
        </div>
      </gz-enumeration-icon>
      <gz-enumeration-icon value="4">
        <div class="inner-steps-section">
          <gz-text fontSize="${FontSizes.HEADING_6}" class='k8s-page-text' id="checkStep4"></gz-text>
        </div>
      </gz-enumeration-icon>
    </div>
    
    <div id="connectClusterSection" class="steps-section">
      <gz-title fontsize='${FontSizes.HEADING_5}' lineHeight='1.2' fontweight='${FontWeights.MEDIUM}' class='k8s-page-title' id='k8sScriptTitle'></gz-title>
      <gz-enumeration-icon value="1">
        <div class="inner-steps-section">
          <gz-text fontSize="${FontSizes.HEADING_6}" id="connectStep1"></gz-text>
          <gz-copy-to-clipboard>
            <div id='downloadHelmChartScript' class='text-placeholder'></div>
          </gz-copy-to-clipboard>
        </div>
      </gz-enumeration-icon>
      <gz-enumeration-icon value="2">
        <div class="inner-steps-section">
          <gz-text fontSize="${FontSizes.HEADING_6}" id="connectStep2"></gz-text>
          <gz-copy-to-clipboard multiLine='true' id='kubernetesDownloadK8sAgentScript'>
            <div id='kubernetesDownloadK8sAgentScriptInput' class='text-placeholder'></div>
          </gz-copy-to-clipboard>
        </div>
      </gz-enumeration-icon>
      <gz-text fontSize="${FontSizes.HEADING_6}" id='k8sScriptFooter'></gz-text>
    </div>

    <gz-title fontsize='${FontSizes.PARAGRAPH_11}' lineHeight='1.2' fontweight='${FontWeights.SEMIBOLD}' class='k8s-page-title' id='verificationTitle'></gz-title>
    <gz-text fontsize='${FontSizes.HEADING_6}' lineHeight='1.2' class='k8s-page-text' id='verificationInstructions'></gz-text>

  </div>
`;
